<template>
  <section v-if="isActive" :id="computedId" ref="tab" class="ui-tab">
    <slot />
  </section>
</template>

<script setup lang="ts">
import {inject, watch, ref} from 'vue';
import type {
  ITabsProvider,
  TAddTab,
  TUpdateTab,
} from '~/interfaces/ui/tabs';

const props = defineProps<{
  id?: string;
  name: string;
  isDisabled?: boolean;
}>();

const isActive = ref(false);
const tabsProvider: ITabsProvider = inject(
  'tabsProvider',
) as ITabsProvider;
const addTab: TAddTab = inject('addTab') as TAddTab;
const updateTab: TUpdateTab = inject('updateTab') as TUpdateTab;
const computedId = props.id
  ? props.id
  : props.name.toLowerCase().replace(/ /g, '-');

watch(
  () => tabsProvider.activeTabId.value,
  () => {
    isActive.value = computedId === tabsProvider.activeTabId.value;
  },
);

watch(
  () => Object.assign({}, props),
  () => {
    updateTab(computedId, {
      name: props.name,
      header: props.name,
      isDisabled: props.isDisabled,
      index: tabsProvider.tabs.value.length,
      computedId,
    });
  },
);

addTab({
  name: props.name,
  header: props.name,
  isDisabled: props.isDisabled,
  index: tabsProvider.tabs.value.length,
  computedId,
});
</script>
